import { Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { isTrue } from "src/service/util.service";
import style from "./OrgChartColleagues.module.scss";

let managersTest = [{ name: "Wutthichai Sisomkhut", position: "Developer", profileUrl: "https://cdn.theorg.com/e8346846-a5c0-4484-8e6b-eb0cd1a823f8_small.jpg" }]
let peersTest = [{ name: "Wutthichai konk", position: "Developer", profileUrl: "https://cdn.theorg.com/e8346846-a5c0-4484-8e6b-eb0cd1a823f8_small.jpg" }
  , { name: "Wutthichai m1", position: "Developer", profileUrl: "https://cdn.theorg.com/e8346846-a5c0-4484-8e6b-eb0cd1a823f8_small.jpg" }
  , { name: "Wutthichai m2", position: "Developer", profileUrl: "https://cdn.theorg.com/e8346846-a5c0-4484-8e6b-eb0cd1a823f8_small.jpg" }
  , { name: "Wutthichai m3", position: "Developer", profileUrl: "https://cdn.theorg.com/e8346846-a5c0-4484-8e6b-eb0cd1a823f8_small.jpg" }
  , { name: "Wutthichai m4", position: "Developer", profileUrl: "https://cdn.theorg.com/e8346846-a5c0-4484-8e6b-eb0cd1a823f8_small.jpg" }]
let childTest = [{ name: "Wutthichai konk", position: "Developer", profileUrl: "https://cdn.theorg.com/e8346846-a5c0-4484-8e6b-eb0cd1a823f8_small.jpg" }
  , { name: "Wutthichai m1", position: "Developer", profileUrl: "https://cdn.theorg.com/e8346846-a5c0-4484-8e6b-eb0cd1a823f8_small.jpg" }
  , { name: "Wutthichai m2", position: "Developer", profileUrl: "https://cdn.theorg.com/e8346846-a5c0-4484-8e6b-eb0cd1a823f8_small.jpg" }
  , { name: "Wutthichai m3", position: "Developer", profileUrl: "https://cdn.theorg.com/e8346846-a5c0-4484-8e6b-eb0cd1a823f8_small.jpg" }
  , { name: "Wutthichai m4", position: "Developer", profileUrl: "https://cdn.theorg.com/e8346846-a5c0-4484-8e6b-eb0cd1a823f8_small.jpg" }]

const OrgChartColleagues = (props: any) => {
  const { t } = useTranslation();

  const [managers, setManagers]: any = useState([]);
  const [peers, setPeers]: any = useState([]);
  const [child, setChild]: any = useState([]);

  useEffect(() => {
    setManagers(managersTest)
    setPeers(peersTest)
    setChild(childTest)
  }, [])

  return (
    <div className={style.rootMain}>
      <div className={style.mainDiv}>
        <div className={style.divBox}>
          <h3 className={style.header}>{t("Manager")}</h3>

          {managers?.map((user: any, idx: number) => {
            return (
              <UserBox
                name={user.name}
                position={user.position}
                profileUrl={user.profileUrl}
                idx={idx}
                activeLink={false}
                useFirst={true}
              />
            );
          })}

        </div>
        <div className={style.divBox}>
          <h3 className={style.header}>{t("Peers")}</h3>
          {peers?.map((user: any, idx: number) => {
            return (
              <UserBox
                name={user.name}
                position={user.position}
                profileUrl={user.profileUrl}
                idx={idx}
                activeLink={false}
                activeFirst={true}
                useFirst={true}
              />
            );
          })}
        </div>
        <div className={style.divBox}>
          <h3 className={style.header}>{t("Childs")}</h3>
          {child?.map((user: any, idx: number) => {
            return (
              <UserBox
                name={user.name}
                position={user.position}
                profileUrl={user.profileUrl}
                idx={idx}
                activeLink={true}
                useFirst={false}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};



const UserBox = (props: any) => {
  const getClassNameMainBox = () => {
    let className = [style.lineBoxNeutral, props.idx > 1 ? style.lineBoxNeutralMore1 : ""].join(" ");
    if (isTrue(props.activeLink)) {
      className = [style.lineBoxActive, props.idx > 1 ? style.lineBoxActiveMore1 : ""].join(" ");
    }
    return className;
  }
  const getClassNameLinkBox = () => {
    let className = [style.clickBox, ""].join(" ");
    if (isTrue(props.useFirst)) {
      if (isTrue(props.activeFirst)) {
        className = [style.clickBox, props.idx === 0 ? style.lineBoxLinkActiveFirst : ""].join(" ");
      } else {
        className = [style.clickBox, props.idx === 0 ? style.lineBoxLinkNeutralFirst : ""].join(" ");
      }

    }
    return className;
  }

  const getClassNameBoxUser = () => {
    let className = [style.boxUser, style.boxUser2].join(" ");
    if (isTrue(props.activeFirst) && props.idx === 0 ) {
      className = [style.boxUser2, style.boxUserActive].join(" ");
    }
    return className;
  }

  return (


    <div className={[style.rootBox, style.divBox2].join(" ")}>

      {props.idx != 0 && <div className={getClassNameMainBox()}></div>}


      <div
        className={getClassNameLinkBox()}

      >
        <div className={getClassNameBoxUser()}>
          <div className={style.rootBoxImage}>
            <div

              className={style.mainImageBox}
            >
              <div >
                <img
                  className={style.imageBox}
                  src={props.profileUrl}
                />
              </div>
            </div>
          </div>
          <div className={style.textBox}>
            <p

              className={[style.fontBox,style.fontBox1].join(" ")}
            >
              {props.name}
            </p>
            <p
              className={[style.fontBox,style.fontBox2].join(" ")}
            >
              {props.position}
            </p>
          </div>
        </div>
      </div>
    </div>

  )
}


export default OrgChartColleagues;
